import React, { useState } from 'react';
import { highlightBoard } from 'helpers/formatter';
import * as Icon from 'react-bootstrap-icons';
import { ManageProfileLocationHistoryCalendar, ManageProfileLocationHistoryMap, ManageProfileLocationHistoryUpload, ManageSavedLocations } from 'sections';

export { Locations };

function Locations() {
    const categories = [{id: 1, title:"Saved Locations"},{ id: 2, title: "Location Calendar"}, {id: 3, title: "Location Calendar" }, {id: 4, title: "Location Upload" }];
    const [category, setCategory] = useState(categories[0]);
    const [active, setActive] = useState(1);
    const handleContent = (e, id) => {
        highlightBoard(e);
        setCategory(categories.filter(item => item.id === id)[0]);
        setActive(id);
    }

    return (
        <div className='panel'>
            <h1><Icon.GeoAltFill size={35} /> Location</h1>
            <p></p>
            <hr></hr>
            <p></p>

            <ul className="nav nav-tabs">
                <li className="nav-item">
                    <a className={active === 1 ? "nav-link active" : "nav-link"} href="/locations"><Icon.Calendar3 size={20}/> Saved Locations</a>
                </li>
                <li className="nav-item">
                    <a className={active === 2 ? "nav-link active" : "nav-link"} href="#" onClick={(e)=> handleContent(e, 2)}><Icon.Calendar3 size={20}/> History Calendar</a>
                </li>
                <li className="nav-item">
                    <a className={active === 3 ? "nav-link active" : "nav-link"} href="#" onClick={(e)=> handleContent(e, 3)}><Icon.GeoAltFill size={20}/> History Map</a>
                </li>
                <li className="nav-item">
                    <a className={active === 4 ? "nav-link active" : "nav-link"} href="#" onClick={(e)=> handleContent(e, 4)}><Icon.CloudUpload size={20}/> History Upload</a>
                </li>
            </ul>
            <p></p>
            {category && category.id === 1 && (
                <ManageSavedLocations/>
            )}
            {category && category.id === 2 && (
                <ManageProfileLocationHistoryCalendar/>
            )}
            {category && category.id === 3 && (
                <ManageProfileLocationHistoryMap/>
            )}
            {category && category.id === 4 && (
                <ManageProfileLocationHistoryUpload/>
            )}
        </div>
    );
}
